import { render } from "./BidForm.vue?vue&type=template&id=f0be4b5e&scoped=true"
import script from "./BidForm.vue?vue&type=script&lang=js"
export * from "./BidForm.vue?vue&type=script&lang=js"

import "./BidForm.vue?vue&type=style&index=0&id=f0be4b5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0be4b5e"]])

export default __exports__